( function( $ ) {
    "use strict";

    var spreadsheet = {
        onClickRow: function(ev) {
            $(this).toggleClass('highlight')
        },

        onClickControlWidthMode: function(ev) {
            ev.preventDefault();

            var $spreadsheet = $(this).closest('[data-spreadsheet]');

            $spreadsheet.toggleClass('confined');
        }
    };

    var $body = $('body');

    $body.on('app.ready', function () {
        $body.on('click.spreadsheet', '[data-spreadsheet] tr[data-spreadsheet-row]', spreadsheet.onClickRow);

        $body.on('click.spreadsheet', '[data-spreadsheet] button[role="control-width-mode"]', spreadsheet.onClickControlWidthMode);
    });

    $body.on('app.init', function () {
        var $spreadsheet = $body.find('[data-spreadsheet]');

        $spreadsheet.find('tr[data-spreadsheet-row] td').each(function () {
            var $td = $(this);

            $td.addClass('spreadsheet-col spreadsheet-col-' + $td.index());
        });

        $spreadsheet.find('tr[data-spreadsheet-row] td').hover(
            function (ev) {
                var $td = $(this),
                    $table = $td.closest('table');

                $table.find('.spreadsheet-col-' + $td.index()).addClass('spreadsheet-col-active');
            },
            function (ev) {
                var $td = $(this),
                    $table = $td.closest('table');

                $table.find('.spreadsheet-col').removeClass('spreadsheet-col-active');
            }
        );
    });

}( require('jquery') ));
